import numbro from 'numbro';

export const toCurrency = (number) => {
  const currency = numbro(number).formatCurrency({ thousandSeparated: true, mantissa: 2, spaceSeparated: false });
  return currency;
};

export const toCurrencynodec = (number) => {
  const currency = numbro(number).formatCurrency({ thousandSeparated: true, mantissa: 0, spaceSeparated: false });
  return currency;
};


export const toPercentage = (number, decimal) => {
  const mantissa = decimal || 0;
  const percent = numbro(number).format({ output: 'percent', mantissa, spaceSeparated: false });
  return percent;
};


export const toNumber = (input, fallback) => {
  let number = (typeof input === 'string') ? numbro.unformat(input) : input;
  return number || fallback || 0;
};

export const round = (val, decimal) => Number(`${Math.round(`${val}e${decimal}`)}e-${decimal}`);
